export const dataFaqList = [
    {
        question:
            'Como posso contratar os serviços de reparo para meu carro?',
        answer:
            '<p>Você pode preencher seus dados no formulário que entramos em contato com você ou ligue em nossa Central de Vendas no telefone: (11) 3616-9082 e fale com um de nossos consultores.</p>',
    },
    {
        question:
            'Se eu contratar os serviços de reparo para meu veículo, em quanto tempo poderei utilizá-los?',
        answer:
            'Os serviços de reparo poderão ser utilizados após o período de carência especificado no documento de <a href="https://www.ituran.com.br/documentos/condicoes-gerais-servicos-ituran.pdf" target="blank">Condições Gerais</a>, consulte-o para mais informações.',
    },
    {
        question: 'Qual o procedimento para eu solicitar um serviço?',
        answer: `<main>
              <p>Desde que os serviços tenham sido contratados, o acionamento poderá ser feito conforme tabela abaixo, de acordo com a necessidade e produto contratado:</p>

              <table class="table">
                <thead>
                  <tr>
                    <th>Prestadora</th>
                    <th>Produto contratado</th>
                    <th>Tipo de serviço</th>
                    <th>Contato</th>
                    <th>Atendimento online</th>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td>Maxpar/Autoglass</td>
                    <td>Assistência de Lataria e Pintura + Martelinho</td>
                    <td>Reparo de lataria ou martelinho</td>
                    <td>0800 777 2116</td>
                    <td>https://abraja.com.br/ituran</td>
                  </tr>
                  <tr>
                    <td>Maxpar/Autoglass</td>
                    <td>Reparos - Pacote Essencial<br/> Reparos - Pacote Exclusivo<br/> Reparos - Pacote Completo</td>
                    <td>Reparo de lataria ou martelinho</td>
                    <td>0800 777 2116</td>
                    <td>https://abraja.com.br/ituran</td>
                  </tr>
                  <tr>
                    <td>Maxpar/Autoglass</td>
                    <td>Proteção para Vidros</td>
                    <td>Reparo de vidros</td>
                    <td>0800 777 2116</td>
                    <td>https://abraja.com.br/ituran</td>
                  </tr>
                  <tr>
                    <td>Maxpar/Autoglass</td>
                    <td>Proteção para Faróis, Lanternas e Retrovisores</td>
                    <td>Reparo de faróis, lanternas ou retrovisores</td>
                    <td>0800 777 2116</td>
                    <td>https://abraja.com.br/ituran</td>
                  </tr>
                  <tr>
                    <td>Maxpar/Autoglass</td>
                    <td>Proteção para Buracos <br/> Incluso no plano Reparos - Pacote Completo</td>
                    <td>Reparo para suspensão, pneu e roda</td>
                    <td>0800 777 2116</td>
                    <td>https://abraja.com.br/ituran</td>
                  </tr>
                </tbody>
              </table>
            </main>`,
    },
    {
        question:
            'Posso escolher o local, onde será realizada a execução do serviço?',
        answer:
            'Os serviços de reparo poderão ser realizados nas lojas credenciadas ou, se houver disponibilidade em domicílio, com possibilidade de cobrança de taxa de deslocamento.',
    },
    {
        question: 'Em quais cidades essas assistências têm cobertura?',
        answer: 'A cobertura é Nacional, em todo o Brasil.',
    },
    {
        question:
            'Quem pode usar o serviço de Assistência Carro Reserva?',
        answer:
            'Os clientes do produto Ituran com Seguro Completo, de forma gratuita, ou que optarem pela contratação da Assistência Carro Reserva como um Serviço Adicional Ituran, com um custo extra na mensalidade. Para ter direito ao benefício, nas situações em que estiverem cobertas pelo plano, o cliente deverá seguir os critérios da locadora. Isto é, ter idade igual ou superior a 21 anos, ser habilitado há pelo menos 02 anos, possuir um cartão de crédito, a ser usado como caução, com limite disponível de no mínimo R$ 1.000,00 e, ter ciência de que, dependendo da locadora disponível para a retirada do veículo, poderá ser solicitado um valor superior de limite no cartão de crédito. Quando o cliente não tiver o perfil informado, será possível indicar um outro condutor, pagando uma taxa diretamente para a locadora.',
    }
]
